export enum PasskeyAction {
  AddPasskey = 'addPasskey',
  Login = 'login',
  ForgotPasswordVerify = 'forgotPasswordVerify',
}
